export default __webpack_public_path__ + "static/media/bg.898c3fe7.mp3";